import styled from "styled-components";

// export const GrayCenterContainer = styled(CenterContainer)`
//   color: #7f7e80;
// `;


export const Subtitle = styled.div`
  text-align: center;
  margin: 30px 0;
`;
